import { render } from "./MenuGroup.vue?vue&type=template&id=2ac58603"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__